/* eslint-disable import/no-extraneous-dependencies */
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

function generateCouponCode() {
  return Array.from({ length: 12 }, () => Math.floor(Math.random() * 16).toString(16).toUpperCase()).join('')
}

export const useCouponForm = (
  handleCreateCoupon,
  setIsModalOpen,
  isModalOpen
) => {
  const {
    control,
    reset,
    getValues,
    watch,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: '',
      validUntil: '',
      maxTimesCanBeUsed: '',
      discountType: 'percentage',
      discountAmount: '',
    },
  })

  const discountType = watch('discountType')

  useEffect(() => {
    if (isModalOpen) {
      setValue('code', generateCouponCode())
    }
  }, [isModalOpen, setValue])

  const handleClose = () => {
    reset()
    setIsModalOpen(false)
  }

  const handleFormSubmit = async () => {
    const isValid = await trigger()

    if (isValid) {
      const formData = getValues()

      const formattedData = {
        coupon: {
          code: formData.code,
          valid_until: formData.validUntil,
          max_usage_count: formData.maxTimesCanBeUsed,
          rebate: discountType === 'rebate' ? formData.discountAmount : '',
          discount:
            discountType === 'percentage' ? formData.discountAmount : '',
        },
      }

      handleCreateCoupon(formattedData)
      handleClose()
    }
  }

  return {
    control,
    errors,
    discountType,
    handleFormSubmit,
    handleClose,
  }
}
